import Light from './Light';
import MagneticObject from './MagneticObject';
import Planes from './Planes';
import Points from './Points';
import ShadowFloor from './ShadowFloor';
import Camera from './Camera';
import BackgroundTexture from './BackgroundTexture';

export * from './calculations';

export const ARCamera = Camera;
export const ARBackgroundTexture = BackgroundTexture;
export const ARLight = Light;
export const ARMagneticObject = MagneticObject;
export const ARPlanes = Planes;
export const ARPoints = Points;
export const ARShadowFloor = ShadowFloor;
export {
  Camera,
  BackgroundTexture,
  Light,
  MagneticObject,
  Planes,
  Points,
  ShadowFloor,
}